import { HTTP } from 'providers'

export interface Alert {
  id: string
  title: string
  htmlContent: string
  icon?: string
  url?: string
}

export class AlertsService extends HTTP {
  private endpoint = '/alert'

  public async getUnseenAlerts() {
    const result = await this.get({
      endpoint: `${this.endpoint}/unseen`
    })
    if (!result || !result.data) {
      console.error('Erro ao buscar alertas não vistos:', result)
      return []
    }
    if (result.status === 200) {
      return result.data
    }
    console.error('Erro ao buscar alertas não vistos:', result)
    return []
  }

  public async markAlertAsSeen(alertId: string) {
    try {
      await this.post({
        endpoint: `${this.endpoint}/${alertId}/seen`
      })
    } catch (error) {
      console.error(`Erro ao marcar alerta ${alertId} como visualizado:`, error)
    }
  }
}
